import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import debounce from 'lodash/debounce';
import CellGalleryItem from './CellGalleryItem';
import CellGalleryImage from './Image';

export default class MemoizedGallerySwiper extends Component {
  constructor(props) {
    super(props);
    this.debouncedOnUpdate = debounce(() => {
      this.props.onUpdate();
    }, 0);
  }

  shouldComponentUpdate(newProps) {
    const isImagesChanged = newProps.images.length !== this.props.images.length;
    const isRtlChanged = newProps.rtl !== this.props.rtl;
    const isLoopChanged = this.props.loop !== newProps.loop;
    const isAutoplayChanged = !!this.props.autoplay !== !!newProps.autoplay;

    return (
      isRtlChanged || isImagesChanged || isLoopChanged || isAutoplayChanged
    );
  }

  componentDidUpdate() {
    this.debouncedOnUpdate();
  }

  renderGalleryItem = (item) => (
    <CellGalleryItem key={item.thumbnail} item={item} />
  );

  render() {
    const { images, setSwiperRef, ...params } = this.props;

    return (
      <Swiper {...params} ref={setSwiperRef}>
        {images.map((item, idx) => (
          <div key={item.thumbnail || idx} className="swiper-slide">
            <CellGalleryImage
              item={item}
            />
          </div>
        ))}
      </Swiper>
    );
  }
}

MemoizedGallerySwiper.propTypes = {
  images: PropTypes.array,
  onUpdate: PropTypes.func,
  rtl: PropTypes.bool,
  loop: PropTypes.bool,
  autoplay: PropTypes.object,
  setSwiperRef: PropTypes.func
};
